<template>
  <div class="text-element-display">
    <div
      :style="element ? element.style : {}"
      :id="'text-' + conIndex + '-' + colIndex + '-' + elindex"
      class="text-editable"
      :contenteditable="contentEditable"
      @click.stop="toggleCurrentColumn($event)"
      @keyup="keyUp"
      @keyup.exact.enter="edit"
      @change="handleDrag"
      @blur="edit"
      v-model="element.value"
      v-on-clickaway="clickedAway"
    >
      {{ this.element.value }}
    </div>
  </div>
</template>

<script>
import { defaultElementStyle } from '../../../config/constanteUse'
import { eventBus } from '../../../main'
import { directive as onClickaway } from 'vue-clickaway'
export default {
  props: {
    element: {
      type: Object,
      required: true,
      defautStyle: defaultElementStyle
    },
    elindex: Number,
    conIndex: Number,
    colIndex: Number,
    elements: Array
  },
  directives: {
    onClickaway: onClickaway
  },
  data () {
    return {
      contentEditable: false,
      doneTypingInterval: 2000,
      isFocused: false
    }
  },
  methods: {
    clickedAway (e) {
      if (
        e.target.classList.contains('focused') ||
        e.target.classList.contains('content-editor') ||
        e.target.classList.length === 0 ||
        e.target.classList.contains('icon-btn') ||
        e.target.classList.contains('input-group') ||
        e.target.classList.contains('form-control')
      ) {
        return
      }

      var zoneTextFocused = document.querySelectorAll('.text-editable')

      if (zoneTextFocused.length > 0) {
        for (var j = 0; j < zoneTextFocused.length; j++) {
          zoneTextFocused[j].classList.remove('focused')
        }
      }

      // var topAction = document.querySelectorAll('.top-action')
      //
      // for (let x = 0; x < topAction.length; x++) {
      //   topAction[x].classList.add('d-none')
      // }

      var containerControls = document.querySelectorAll('.container-controls')
      for (let j = 0; j < containerControls.length; j++) {
        containerControls[j].classList.add('d-none')
      }
      let allCol = document.querySelectorAll('.top-level-col')

      if (allCol.length > 0) {
        for (var i = 0; i < allCol.length; i++) {
          allCol[i].classList.remove('temp-col-deselect')
        }
      }

      if (
        document.getElementById(
          'text-' + this.conIndex + '-' + this.colIndex + '-' + this.elindex
        )
      ) {
        if (
          document
            .getElementById(
              'text-' + this.conIndex + '-' + this.colIndex + '-' + this.elindex
            )
            .closest('.text-content')
        ) {
          document
            .getElementById(
              'text-' + this.conIndex + '-' + this.colIndex + '-' + this.elindex
            )
            .closest('.text-content')
            .previousElementSibling.classList.add('d-none')
        }
      }

      if (
        document.getElementById('col-' + this.conIndex + '-' + this.colIndex)
      ) {
        document
          .getElementById('col-' + this.conIndex + '-' + this.colIndex)
          .querySelector('.container-controls')
          .classList.add('d-none')
        document
          .getElementById('col-' + this.conIndex + '-' + this.colIndex)
          .querySelector('.but-group')
          .classList.add('inactive')
      }
    },
    edit (e) {
      this.element.value = e.target.innerText
      // e.target.closest('.top-level-col').classList.remove('temp-col-deselect')
      this.$emit('elementUpdate', this.element)
    },
    keyUp () {
      let typingTimer

      eventBus.$emit('activateTextButton', {
        hideTrash: 'd-none'
      })

      clearTimeout(typingTimer)
      typingTimer = setTimeout(function () {
        eventBus.$emit('activateTextButton', {
          hideTrash: ''
        })
      }, this.doneTypingInterval)
    },
    handleDrag () {
      this.$emit('dropEdit', this.element.childElements)
    },
    toggleCurrentColumn (e) {
      if (this.$route.name === 'edit_fiche_espace') {
        this.isFocused = true
        this.contentEditable = true
        eventBus.$emit('activateTextButton')
        var zoneTextFocused = document.querySelectorAll('.text-editable')

        if (zoneTextFocused.length > 0) {
          for (var j = 0; j < zoneTextFocused.length; j++) {
            zoneTextFocused[j].classList.remove('focused')
          }
        }

        var cedit = document.querySelectorAll('.cedit')

        if (cedit.length > 0) {
          for (var l = 0; l < cedit.length; l++) {
            cedit[l].classList.remove('thecolselected')
          }
        }

        var handle = document.querySelectorAll('.the-handle')

        if (handle.length > 0) {
          for (var k = 0; k < handle.length; k++) {
            handle[k].classList.remove('show')
          }
        }

        let allCol = document.querySelectorAll('.top-level-col')

        if (allCol.length > 0) {
          for (var i = 0; i < allCol.length; i++) {
            allCol[i].classList.remove('columnActive')
          }
        }

        var containerControls = document.querySelectorAll(
          '.container-controls'
        )
        for (let j = 0; j < containerControls.length; j++) {
          containerControls[j].classList.add('d-none')
        }

        var topAction = document.querySelectorAll('.top-action')

        for (let x = 0; x < topAction.length; x++) {
          topAction[x].classList.add('d-none')
        }

        document
          .getElementById(
            'text-' + this.conIndex + '-' + this.colIndex + '-' + this.elindex
          )
          .classList.add('focused')
        document
          .getElementById(
            'text-' + this.conIndex + '-' + this.colIndex + '-' + this.elindex
          )
          .closest('.text-content')
          .previousElementSibling.classList.remove('d-none')
        document
          .getElementById('col-' + this.conIndex + '-' + this.colIndex)
          .classList.add('temp-col-deselect')
        document
          .getElementById('col-' + this.conIndex + '-' + this.colIndex)
          .querySelector('.container-controls')
          .classList.remove('d-none')
        document
          .getElementById('col-' + this.conIndex + '-' + this.colIndex)
          .querySelector('.but-group')
          .classList.remove('inactive')

        var toolbarButtons = document.querySelectorAll('.disabled-action')

        for (let i = 0; i < toolbarButtons.length; i++) {
          toolbarButtons[i].classList.remove('disabled-action')
        }

        eventBus.$emit('selected', {
          element: this.element,
          elindex: this.elindex,
          colIndex: this.colIndex,
          conIndex: this.conIndex,
          type: 'content'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.text-editable.focused {
  outline: none !important;
  box-shadow: 0 0 2px 3px #9395c1;
}
.text-element-display {
  min-height: fit-content;
  /*text-align: center;*/
  /*font-size: 16px;*/
}
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/display/textElement.vue